<template>
  <v-col class="box-content" cols="12" sm="9" md="6" xl="3">
    <!-- <Back /> -->
    <Logo />
    <h1 class="mb-1 hidden">Sign up</h1>
    <div class="label-forgot mb-4">
      <span @click="$router.push({ path: '/auth/login', query: { ...$route.query } })"
        >Already have an account? <strong class="text-decoration-underline pointer">Sign in</strong></span
      >
    </div>
    <Notification v-if="errorMessage.length > 0" :messages="errorMessage" type="error" />
    <div class="d-md-flex">
      <div class="flex-1 mr-md-3">
        <span class="label-form"> Email </span>
        <v-text-field
          autocomplete="off"
          name="email"
          id="email"
          v-model.trim="$v.email.$model"
          :error-messages="
            invalid && !$v.email.required
              ? $t('Field is required')
              : invalid && !$v.email.email
              ? $t('Invalid Email')
              : invalid && !$v.email.minLength
              ? $t('Email must have at least ' + $v.email.$params.minLength.min + ' letters.')
              : invalid && !$v.email.maxLength
              ? $t('Email must have at least ' + $v.email.$params.maxLength.max + ' letters.')
              : ''
          "
        ></v-text-field>
      </div>
      <div class="flex-1 mr-ml-3">
        <span class="label-form"> Password </span>
        <v-text-field
          :type="type"
          autocomplete="off"
          name="password"
          id="password"
          v-model.trim="$v.password.$model"
          :error-messages="
            invalid && !$v.password.required
              ? $t('Password is required')
              : invalid && !$v.password.minLength
              ? $t('Password must have at least ' + $v.password.$params.minLength.min + ' letters.')
              : invalid && !$v.password.maxLength
              ? $t('Password must have at least ' + $v.password.$params.maxLength.max + ' letters.')
              : ''
          "
        >
          <template slot="append">
            <i
              @click="type = type === 'text' ? 'password' : 'text'"
              v-show="type === 'text'"
              class="show-password far fa-eye-slash"
            ></i>
            <i
              v-show="type === 'password'"
              @click="type = type === 'text' ? 'password' : 'text'"
              class="show-password far fa-eye"
            ></i>
          </template>
        </v-text-field>
      </div>
    </div>
    <div>
      <span class="label-form"> Shop Name </span>
      <v-text-field
        v-on:keyup.enter="onSignup"
        autocomplete="off"
        name="shop_name"
        id="shop_name"
        v-model.trim="$v.shopName.$model"
        :error-messages="
          invalid && !$v.shopName.required
            ? $t('Shop name is required')
            : invalid && !$v.shopName.minLength
            ? $t('Shop name must have at least ' + $v.shopName.$params.minLength.min + ' letters.')
            : invalid && !$v.shopName.maxLength
            ? $t('Shop name must have at least ' + $v.shopName.$params.maxLength.max + ' letters.')
            : invalid && !$v.shopName.alpha
            ? $t('Shop name cannot contain special characters')
            : ''
        "
      ></v-text-field>
    </div>

    <div class="mt-5">
      <v-btn @click="onSignup" :loading="isLoading" width="100%" color="primary">
        Sign Up
      </v-btn>
    </div>
  </v-col>
</template>

<script>
import { required, minLength, maxLength, email, helpers } from 'vuelidate/lib/validators';
const alpha = helpers.regex('alpha', /^[a-zA-Z0-9]*$/);
import { authService } from '@/apis/auth.s';
import STORAGE_NAME from '@/const/storage';
import Notification from '@/components/Notification';
import { mapMutations } from 'vuex';
import accountRequest from '@/apis/request/accountRequest';
// import Back from './Back.vue';
import { storeService } from '@/apis/store.s';
import { userService } from '@/apis/user.s';
import Logo from './Logo.vue';

export default {
  components: {
    Notification,
    // Back,
    Logo,
  },
  data() {
    return {
      type: 'password',
      isLoading: false,
      email: '',
      password: '',
      shopName: '',
      invalid: false,
      errorMessage: [],
      stores: [],
    };
  },
  validations: {
    email: {
      required,
      email,
      minLength: minLength(4),
      maxLength: maxLength(50),
    },
    password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(50),
    },
    shopName: {
      required,
      alpha,
      minLength: minLength(4),
      maxLength: maxLength(50),
    },
  },
  methods: {
    /*
    Fnc Signup
    */
    async onSignup() {
      this.isLoading = true;
      this.$v.$touch();
      this.invalid = this.$v.$invalid;
      this.errorMessage = [];
      if (!this.$v.$invalid) {
        try {
          const codeRef = this.$store.state.auth.codeRefCreateStore;
          let data = await authService.register(this.email, this.password, this.shopName, codeRef);
          window.localStorage.setItem(STORAGE_NAME.ACCESS_TOKEN, data.data.accessToken || '');
          window.localStorage.setItem(STORAGE_NAME.REFRESH_TOKEN, data.data.refreshToken || '');
          window.localStorage.setItem(STORAGE_NAME.STORE_ID, data.data.storeId || '');
          this.isLoading = false;
          accountRequest.setToken(data.data.accessToken);

          await this.getStores();
          let storeId = data.data.storeId;
          let findStore = this.stores.find(s => s.id === storeId);
          let defaultSystemDomain = findStore ? findStore.storeDetail.defaultSystemDomain : '';
          localStorage.setItem(STORAGE_NAME.STORE_DOMAIN, defaultSystemDomain);
          await this.addPayments(storeId);

          setTimeout(() => {
            this.$router.push({ name: 'auth/survey', query: { register: '' } });
          }, 1000);
        } catch (error) {
          this.errorMessage = error;
          this.isLoading = false;
        }
      } else {
        this.isLoading = false;
      }
    },

    async addPayments(storeId) {
      try {
        let payments = await storeService.addPayments(storeId);
        console.log('payments', payments);
      } catch (error) {
        console.log(error.response);
      }
    },

    async getStores() {
      try {
        let data = await userService.getStores();
        this.stores = data.data.reverse().filter(store => store !== null);
      } catch (error) {
        console.log(error.response);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
h1 {
  font-size: 3.2rem;
}
.show-password {
  cursor: pointer !important;
  margin-right: 5px;
  margin-top: 10px;
}
.label-forgot {
  font-size: 14px;
  color: #64748b;
  &.text-right {
    color: var(--v-primary-base);
    &:hover {
      text-decoration: underline;
    }
  }
  span {
    font-size: 14px;
    cursor: pointer;
  }
}

@media (min-width: 768px) {
  .flex-1 {
    flex: 1;
  }
}
</style>
